<script setup lang="ts">
/**
 * A short line on the sign-in family of screens: a refusal (red well, flame)
 * or a hint (steel well, bell), with its painted icon. One line of lettering,
 * never a paragraph; the caller supplies the words.
 */

withDefaults(defineProps<{ tone?: 'error' | 'hint' }>(), { tone: 'hint' });
</script>

<template>
  <p class="k-well notice" :class="tone" :role="tone === 'error' ? 'alert' : undefined">
    <span class="text"><slot /></span>
  </p>
</template>

<style scoped>
.notice {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  padding: 8px 12px 8px 8px;
  font-family: var(--font-game-body);
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.35;
  color: #dbe5ee;
}

.notice.error {
  background: linear-gradient(180deg, rgba(96, 18, 14, 0.7), rgba(70, 12, 10, 0.6));
  box-shadow:
    inset 0 2px 6px rgba(0, 0, 0, 0.55),
    0 0 0 2px #c8241c;
  color: #ffe3de;
}

.text {
  min-width: 0;
  overflow-wrap: anywhere;
}
</style>
